export const WOEZOR_SUPER = "WOEZOR_SUPER"
export const WOEZOR_ADMIN = "WOEZOR_ADMIN"
export const SUPER_ADMIN_TYPES = [WOEZOR_SUPER, WOEZOR_ADMIN] as const

/** API may return userType as a single string (legacy) or string[] (multi-role). */
export function normalizeUserTypes(
  userType: string | string[] | null | undefined
): string[] {
  if (userType == null) return []
  return Array.isArray(userType) ? userType : [userType]
}

export function hasUserType(
  user: { userType?: string | string[] | null } | null | undefined,
  role: string
): boolean {
  return normalizeUserTypes(user?.userType).includes(role)
}

export function hasAnyUserType(
  user: { userType?: string | string[] | null } | null | undefined,
  roles: readonly string[]
): boolean {
  const types = normalizeUserTypes(user?.userType)
  return roles.some((r) => types.includes(r))
}

export function isSuperAdmin(
  user: { userType?: string | string[] | null } | null | undefined
): boolean {
  return hasAnyUserType(user, SUPER_ADMIN_TYPES)
}
